var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysisNotAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 141,
    viewBox: "0 0 166 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_450_4254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.46 116.41C6.34 116.41 3 113.07 3 108.95V10.5498C3 6.42984 6.34 3.08984 10.46 3.08984H155.53C159.65 3.08984 162.99 6.42984 162.99 10.5498V107.26C162.99 107.26 163.28 116.4 154.2 116.4",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75.9001 67.8698L59.1701 94.4898C55.6601 100.07 59.6701 107.34 66.2701 107.34H99.7301C106.33 107.34 110.34 100.08 106.83 94.4898L90.1001 67.8698C86.8101 62.6398 79.1901 62.6398 75.9001 67.8698Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M84.6301 76.23C84.9301 76.23 85.1801 76.48 85.1801 76.78V92.39C85.1801 92.69 84.9301 92.94 84.6301 92.94H81.3701C81.0701 92.94 80.8201 92.7 80.8201 92.39V76.78C80.8201 76.48 81.0601 76.23 81.3701 76.23H84.6301ZM84.6301 94.85C84.9301 94.85 85.1801 95.09 85.1801 95.4V98.68C85.1801 98.98 84.9301 99.23 84.6301 99.23H81.3701C81.0701 99.23 80.8201 98.98 80.8201 98.68V95.4C80.8201 95.1 81.0601 94.85 81.3701 94.85H84.6301Z",
    fill: "#B8B5DD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.04 15.8999H21V22.4399H36.04V15.8999Z",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M62.7199 15.8999H47.6799V22.4399H62.7199V15.8999Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M89.4001 15.8999H74.3601V22.4399H89.4001V15.8999Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M116.07 15.8999H101.03V22.4399H116.07V15.8999Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M145 33.3799H21V137.91H145V33.3799Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_450_4254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 139.82,
    fill: "white",
    transform: "translate(0.5 0.589844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisNotAvailable);
export default __webpack_public_path__ + "static/media/analysis-not-available.5c68b97758e85227b52ef1ccb276a92e.svg";
export { ForwardRef as ReactComponent };